import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
export const resetPassword = (data) => {
    cancelToken = getAxiosCancelToken(cancelToken);
  return (apiRequestType(apiTypes.PUT,apiConstants.PROFILE.RESET_PASSWORD, data, cancelToken));
}

export default resetPassword;
